import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingFacade } from '@domains/loading/loading.facade';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    standalone: false// eslint-disable-line @angular-eslint/prefer-standalone
})
export class LoadingComponent implements OnInit {
  zIndex$ = this.facade.zIndex$;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private facade: LoadingFacade
  ) { }

  ngOnInit() {
    // ナビゲーションの終了時、スピナーを非表示する
    // また、ページ最上部にスクロールする
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.spinner.hide();
      const sidenavContent = document.querySelector('.mat-sidenav-content');
      if (sidenavContent) {
        sidenavContent.scrollTop = 0;
      }
    });
  }
}